/* eslint-disable camelcase */
export default {
  autoship: "AUTOSHIP STATUS",
  yes: "YES",
  no: "NO",
};
